import { orgAPI } from './api';

export async function accessDestination(user) {
  if (user?.must_change_password) return '/cuenta/seguridad';
  try {
    const context = await orgAPI.myContext();
    if ((context.roles || []).length) return context.accessible_scope === 'ALL' ? '/admin/nacional' : '/admin/afiliaciones';
  } catch (_) {
    // Ordinary accounts do not require an administrative assignment.
  }
  return '/dashboard';
}
